<section #game>
  @if (userInfo) {
    <section id="bgID" class="game-box">
      <header>
        <div class="container">
          <div class="header-row">
            <div class="logo-box">
              <img src="assets/images/logo.png">
            </div>
            <nav class="menu">
              <ul>
                <li>
                  <a [routerLink]="['/game']">
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/game/stories']" class="Stories">
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/game/videos']" class="videos">
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/game/books']" class="books">
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/game/songs']" class="songs">
                  </a>
                </li>
              </ul>
            </nav>
            <div class="profile-box">
              <div class="avatar" [routerLink]="[ '/game/profile']">
                @if (userInfo) {
                  <img [src]="'assets/images/header/avatars/'+ userInfo.avatar + '.png'" alt="{{userInfo.name}}">
                }
              </div>
              @if (userInfo) {
                <div class="name-box" [routerLink]="[ '/game/profile']">{{name}}</div>
                @if (!isAdmin) {
                  <div class="points">{{totalScore}}</div>
                }
                @if (isAdmin) {
                  <div class="points" [routerLink]="[ '/admin']">Admin</div>
                }
                @if (assignmentService.showAssignmentPopUp) {
                  <span class="assignment-bell" (click)="showAssignmentPopupClick()">
                    <svg style="width:20px;height:20px" viewBox="0 0 24 24">
                      <path fill="currentColor" d="M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M14,21A2,2 0 0,1 12,23A2,2 0 0,1 10,21M19.75,3.19L18.33,4.61C20.04,6.3 21,8.6 21,11H23C23,8.07 21.84,5.25 19.75,3.19M1,11H3C3,8.6 3.96,6.3 5.67,4.61L4.25,3.19C2.16,5.25 1,8.07 1,11Z" />
                    </svg>
                  </span>
                }
              }
              <button type="button" (click)="logout()" class="logout"></button>
            </div>
          </div>
        </div>
      </header>
      <main>
        <div class="container">
          <div [ngClass]="{frame: hasFrame}">
            <router-outlet></router-outlet>
            @if (completion) {
              <div class="complete quiz continent">
                <h2 class="title">
                  <span class="main-text">{{completion.continent}}</span>
                  <span class="bg-text">{{completion.continent}}</span>
                </h2>
                <div class="center-box">
                  <div class="cert-box">
                    <div class="sert">
                      <img src="/assets/images/awards/QuizImages/{{completion.continent}}.png">
                      <div class="cert-text">
                        <div class="name">{{userInfo.name}}</div>
                        <div class="date">{{today | date: 'dd-MM-yyyy'}}</div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="box-style">
                      You have earned a certificate for successfully completing {{completion.continent}}.
                    </p>
                  </div>
                </div>
                <button type="button" (click)="next()" class="next-activity"></button>
              </div>
            }
            @if (completion) {
              <img class="frame-bg" style="z-index: 10" src="assets/images/activity/quiz/quizWellDone.jpg">
            }
          </div>
        </div>
      </main>
    </section>
  }
</section>

@if (pay) {
  <div class="alert-pop-up" style="text-align: center !important;">
    <div class="alert-pop-up-in" style="width: 550px !important">
      <h2>Subscription for {{userInfo?.name}}</h2>
      @if (firstChild()) {
        <div class="text" style="font-size: 20px; text-align: center; margin-top:15px !important">
          Start your 7 Day Free Trial to continue learning. <br>Your child deserves it.
        </div>
      }
      @if (!firstChild()) {
        <div class="text" style="font-size: 20px; text-align: center; margin-top:15px !important">
          Activate your paid membership to continue learning. <br>Your child deserves it.
        </div>
      }
      <div style="display: flex; justify-content: center;">
        <button style=" margin-right: 0 !important; margin-bottom: 0 !important; height: 50px; font-size: 18px" type="button" mat-flat-button color="accent" (click)="okClick()">
          Get Started
        </button>
      </div>
    </div>
  </div>
}

@if (showAssignmentDone) {
  <div class="alert-pop-up" style="text-align: center !important;">
    <div class="alert-pop-up-in" style="width: 500px !important; padding: 30px 50px; border-radius: 10px">
      <h2>{{assignmentDoneTitle}}</h2>
      @if (assignmentDoneLesson > 0) {
        <div class="text" style="font-size: 20px; text-align: center; margin-top:15px !important">
          You completed the assignment, <span style="color: #61a5de !important">{{assignmentDoneLessonText}}</span>.
          <div style="padding-top: 10px">Now go to your next task.</div>
        </div>
      }
      @if (assignmentDoneLesson < 0) {
        <div class="text" style="font-size: 20px; text-align: center; margin-top:15px !important">
          <div style="padding-top: 10px"> There are no more assignments left.</div>
        </div>
      }
      <div style="display: flex; justify-content: center; padding: 15px">
        <button style=" margin-right: 0 !important; margin-bottom: 0 !important; height: 50px; font-size: 18px" type="button" mat-flat-button color="accent" (click)="closeAssignmentCongrat()">Ok</button>
      </div>
    </div>
  </div>
}

@if (showAssignmentPopup) {
  <div class="alert-pop-up">
    <div class="alert-pop-up-in" style="border-radius: 10px; width: 520px; padding-left: 30px; padding-right: 30px;">
      <div style="text-align: center;">
        <h4 style="display: inline-block; margin: 0 auto 25px; font-size: 25px!important">Your Assignments</h4>
        <span style="float: right;font-size: 1.1em; cursor: pointer;padding: 0px 5px;" class="close" aria-label="Close" (click)="closeAssignmentPopup($event)">×</span>
      </div>
      @if (showAssignmentWarning) {
        <div class="text" style="color: #707070; margin-bottom: 25px;">You need to finish your assignments to unlock access to other lessons.</div>
      }
      <div class="text">Please select the lesson:</div>
      <div class="alert-pop-up-in-content" style="margin-top: 10px!important; background-color: #f6f7f9; border-radius: 5px ; padding-bottom: 20px;">
        @for (item of assignmentService.lessonsListView; track item) {
          <div style="display: inline-flex; justify-content: center; align-items: center;">
            <ng-container>
              <button [disabled]="item.allDone" (click)="goToGame(item)" type="button" mat-icon-button color="accent" style="min-width: auto;display: inline-block; margin: 5px; margin-top: 0px;">
                <svg style="width:30px;height:30px" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M10,16.5L16,12L10,7.5V16.5Z" />
                </svg>
              </button>
              <div [ngStyle]="{'pointer-events': item.allDone ? 'none' : 'inherit' }" (click)="goToGame(item)" style="cursor: pointer !important; color: #43bbab; min-width: 200px;">{{item.assignment.title}}</div>
              <div style="margin-left: 70px; color: #43bbab;"> Due {{toDateString(item.assignment.endDate.seconds)}} </div>
            </ng-container>
          </div>
        }
      </div>
    </div>
  </div>
}

<span class="assignment-bell-warning" hidden (click)="showAssignmentWarningPopupClick()"></span>

<audio id="menuButtonHover">
  <source src="assets/match-the-word/sounds/open-button-hover.mp3" type="audio/mpeg">
</audio>
<audio id="menuButtonClick">
  <source src="assets/sounds/button12.wav" type="audio/wav">
</audio>
<audio id="congratulationsAsia">
  <source src="assets/games/quiz/assets/audios/congratulations/completion-asia.mp3" type="audio/mpeg">
</audio>
<audio id="congratulationsEurope">
  <source src="assets/games/quiz/assets/audios/congratulations/completion-europe.mp3" type="audio/mpeg">
</audio>
<audio id="congratulationsAfrica">
  <source src="assets/games/quiz/assets/audios/congratulations/completion-africa.mp3" type="audio/mpeg">
</audio>

<app-inner-log-in></app-inner-log-in>
